import type { BrowserEngineRequest, NikolaActivity } from "@chessla/shared";

interface Progress {
  depth: number;
  targetDepth: number;
  nodes: number;
}

export const browserEngineActivity = (request: BrowserEngineRequest, progress?: Progress): NikolaActivity => {
  const tablebase = request.kind === "tablebase";
  const label = tablebase
    ? "VERIFYING THIS ENDGAME"
    : request.kind === "move_comparison"
      ? "COMPARING THESE MOVES"
      : request.mode === "plans"
        ? "BUILDING VERIFIED CANDIDATE PLANS"
        : request.mode === "practical"
          ? "WEIGHING PRACTICAL CHOICES"
          : request.mode === "robustness"
            ? "CHECKING DEPTH STABILITY"
            : "VERIFYING THIS POSITION";
  return {
    kind: tablebase ? "position_checked" : "line_compared",
    icon: request.kind === "move_comparison" ? "candidate_comparison" : "line_evaluation",
    status: "running",
    label,
    detail: progress
      ? `DEPTH ${progress.depth} OF ${progress.targetDepth} · ${progress.nodes.toLocaleString()} NODES`
      : tablebase
        ? "CHECKING THE EXACT RESULT AND LEGAL CONTINUATION"
        : "PREPARING THE VERIFIED POSITION",
    ...(progress && progress.targetDepth > 0 ? { progress: (progress.depth / progress.targetDepth) * 100 } : {}),
  };
};
